import { svg } from 'lit';

export const arrowRightIcon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15 12L10 7V17L15 12Z" fill="#786E5C"/>
</svg>`;
